import SectionWrapper from '../../pass-templates-new/SectionWrapper';
import {
  Box,
  Button,
  Flex,
  FormLabel,
  Link,
  Text,
  Textarea,
  useToast,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomArrowRightIcon } from '../../../../theme/icons/CustomArrowRightIcon';
import { useSendNotificationMutation } from '../../../../store/redux/api/passApi';
import CustomToast from '../../../../common/CustomToast';

const NOTIFICATION_MESSAGE_MAX_CHARS = 250;

const SendTestNotificationSection = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const [notificationMessage, setNotificationMessage] = useState('');
  const [sendNotification, { isLoading }] = useSendNotificationMutation();
  const toast = useToast();
  return (
    <SectionWrapper
      title="Send a test notification"
      subtitle={
        <Text fontSize="15px" color="grey">
            Sends a one-off notification to this pass only. Use this to test how
            notifications appear on the holder's device.
        </Text>
      }
      openOnLoad
      id="send-test-notification-section"
    >
      <Box>
        <FormLabel variant="templateBuilderLabel" mb="8px">
          Notification message
        </FormLabel>
        <Textarea
          variant="outlined"
          value={notificationMessage ?? ''}
          placeholder="Enter test message..."
          rows={2}
          maxLength={NOTIFICATION_MESSAGE_MAX_CHARS}
          resize="vertical"
          borderRadius="5px"
          onChange={(e) => {
            const next = e.target.value.slice(
              0,
              NOTIFICATION_MESSAGE_MAX_CHARS
            );
            setNotificationMessage(next);
          }}
        />
        <Text fontSize="12px" color="#666666" mt="8px" pl={1}>
          ({(notificationMessage ?? '').length}/{NOTIFICATION_MESSAGE_MAX_CHARS}{' '}
          characters)
        </Text>
        <Button
          variant="dark"
          size="sm"
          mt="24px"
          isDisabled={!notificationMessage}
          isLoading={isLoading}
          onClick={async () => {
            if (!uuid || !notificationMessage) return;
            try {
              await sendNotification({ uuid, message: notificationMessage }).unwrap();
              setNotificationMessage('');
              toast({
                render: (props) => (
                  <CustomToast
                    status="success"
                    title="Notification sent"
                    description=""
                    onClose={props.onClose}
                    position="top"
                    duration={2000}
                    id={props.id}
                  />
                ),
              });
            } catch {
              toast({
                render: (props) => (
                  <CustomToast
                    status="error"
                    title="Failed to send notification"
                    description="Please try again"
                    onClose={props.onClose}
                  />
                ),
              });
            }
          }}
        >
          Send notification
        </Button>
        <Text fontSize="12px" color="#666666" pl={1} mt="24px">
          To notify all holders of this template, go to{' '}
          <Link href="/messaging">
            <Text as="span" color="#009BD6">
              Messaging
            </Text>
          </Link>{' '}
          <CustomArrowRightIcon
            boxSize="10px"
            color="#009BD6"
            display="inline"
            verticalAlign="middle"
          />
        </Text>
      </Box>
    </SectionWrapper>
  );
};

export default SendTestNotificationSection;
